export default __webpack_public_path__ + "static/media/reliable-icon.ae06d7b9.svg";